import { UrlList } from 'app/main/pages/authentication/shared/url-list.enum';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class FeatureConfigService {
    constructor(http) {
        this.http = http;
    }
    /**
     * Service for retrieving feature notification translation metadata from backend endpoints.
     *
     * Provides methods to fetch metadata for a specific feature, all active features, or the first active feature,
     * using language and configuration parameters. Uses organization-specific URL constants and Angular HttpClient.
     */
    getFeatureMetadata(featureKey, lang) {
        const url = `${UrlList.FEATURE_NOTIFICATION_TRANSLATION}?languageCode=${lang}&configurationName=${featureKey}`;
        return this.http.get(url);
    }
    /**
     * Service for retrieving feature notification translation metadata from backend endpoints.
     *
     * Provides methods to fetch metadata for a specific feature, all active features, or the first active feature,
     * using language and configuration parameters. Utilizes organization-specific URL constants and Angular HttpClient.
     *
     * Methods:
     * - getFeatureMetadata: Fetches metadata for a given feature key and language.
     * - getAllActiveFeatureMetadata: Retrieves all active feature metadata for a given language.
     * - getFirstActiveFeatureMetadata: Gets the first active feature metadata for a given language, or null if none exist.
     */
    getAllActiveFeatureMetadata(lang) {
        const url = `${UrlList.FEATURE_NOTIFICATION_TRANSLATION_ACTIVE}?languageCode=${lang}`;
        return this.http.get(url);
    }
    /**
     * Service for retrieving feature notification translation metadata from backend endpoints.
     *
     * Provides methods to fetch metadata for a specific feature, all active features, or the first active feature,
     * using language and configuration parameters. Utilizes organization-specific URL constants and Angular HttpClient.
     *
     * Methods:
     * - getFeatureMetadata: Fetches metadata for a given feature key and language.
     * - getAllActiveFeatureMetadata: Retrieves all active feature metadata for a given language.
     * - getFirstActiveFeatureMetadata: Gets the first active feature metadata for a given language, or null if none exist.
     */
    getFirstActiveFeatureMetadata(lang) {
        return this.getAllActiveFeatureMetadata(lang).pipe(map(arr => (arr && arr.length > 0 ? arr[0] : null)));
    }
}
FeatureConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureConfigService_Factory() { return new FeatureConfigService(i0.ɵɵinject(i1.HttpClient)); }, token: FeatureConfigService, providedIn: "root" });
